import { render, staticRenderFns } from "./ExternalCouponCenterPage.vue?vue&type=template&id=1227090a&"
import script from "./ExternalCouponCenterPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalCouponCenterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports